type AddressInputType = {
  city: string;
  country: "GB";
  postalCode: string;
  street: string;
};

type FormatAddressResult =
  | { error: true; errorMessage: string; data: null }
  | {
      error: false;
      errorMessage: null;
      data: {
        city: string;
        country: "GB";
        postal_code: string;
        street_address: string;
      };
    };

export const formatAddress = (input: AddressInputType): FormatAddressResult => {
  if (!input || typeof input !== "object") {
    return {
      error: true,
      errorMessage: "Invalid input: address must be a non-empty object",
      data: null,
    };
  }

  let { city, country, postalCode, street } = input;

  // Validate city
  if (!city || typeof city !== "string" || city.trim().length < 2) {
    return {
      error: true,
      errorMessage: "Invalid city: must be a string with at least 2 characters",
      data: null,
    };
  }
  city = city.trim();

  // Validate country
  if (country !== "GB") {
    return {
      error: true,
      errorMessage: "Invalid country: only 'GB' is supported",
      data: null,
    };
  }

  // Normalize nullable postalCode
  let normalizedPostalCode: string = " ";

  const cleanedPostalCode = postalCode.trim().toUpperCase();
  const postalRegex = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/;
  if (!postalRegex.test(cleanedPostalCode)) {
    return {
      error: true,
      errorMessage: `Invalid UK postal code format: "${postalCode}"`,
      data: null,
    };
  }
  normalizedPostalCode = cleanedPostalCode;

  // Validate street
  if (!street || typeof street !== "string" || street.trim().length < 2) {
    return {
      error: true,
      errorMessage:
        "Invalid street: must be a string with at least 2 characters",
      data: null,
    };
  }
  street = street.trim();

  return {
    error: false,
    errorMessage: null,
    data: {
      city,
      country,
      postal_code: normalizedPostalCode,
      street_address: street,
    },
  };
};
